import Comp from './Form'

export default Comp
